import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import './ChoiceIcon.css';

export type ChoiceIconTone = 'accent' | 'support' | 'warning' | 'info' | 'success';

export interface ChoiceIconProps {
  children: ReactNode;
  tone?: ChoiceIconTone;
}

/** Tinted disc for a Choice leading icon — meet, send, decide later. */
export function ChoiceIcon({ children, tone = 'accent' }: ChoiceIconProps) {
  return <span className={classes('choice-icon', `choice-icon--${tone}`)}>{children}</span>;
}
